import { cn as e } from "../../lib/utils.es.js";
import { getEmbedPortalContainer as t } from "../../lib/embed-portal-container.es.js";
import * as n from "react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import * as a from "@radix-ui/react-tooltip";
// libs/ui-lib/src/components/ui/tooltip.tsx
function o({ delayDuration: e = 0, ...t }) {
	return /* @__PURE__ */ r(a.Provider, {
		"data-slot": "tooltip-provider",
		delayDuration: e,
		...t
	});
}
function s({ ...e }) {
	return /* @__PURE__ */ r(o, { children: /* @__PURE__ */ r(a.Root, {
		"data-slot": "tooltip",
		...e
	}) });
}
var c = n.forwardRef(({ ...e }, t) => /* @__PURE__ */ r(a.Trigger, {
	ref: t,
	"data-slot": "tooltip-trigger",
	...e
}));
c.displayName = "TooltipTrigger";
function l({ className: n, sideOffset: o = 0, container: s, children: c, ...l }) {
	return /* @__PURE__ */ r(a.Portal, {
		container: s ?? t() ?? void 0,
		children: /* @__PURE__ */ i(a.Content, {
			"data-slot": "tooltip-content",
			sideOffset: o,
			className: e("bg-primary text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance", n),
			...l,
			children: [c, /* @__PURE__ */ r(a.Arrow, { className: "bg-primary fill-primary z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" })]
		})
	});
}
export { s as Tooltip, l as TooltipContent, o as TooltipProvider, c as TooltipTrigger };
